import React, { useEffect } from "react";
import tw, { styled } from "twin.macro";

const EmbedContainer = styled.div`
  ${tw`max-h-[600px] overflow-hidden text-xs`}
`;

const TwitterTimeline = ({ timelineAccount }) => {
  useEffect(() => {
    // attach script tag inside embed container
    if (typeof document !== undefined) {
      const script = document.createElement("script");
      script.src = "https://platform.twitter.com/widgets.js";
      script.defer = true;
      const containerElement = document.querySelector("#twitter-embed");
      containerElement.appendChild(script);
      return () => {
        containerElement.removeChild(script);
      };
    }
  }, []);
  return (
    <EmbedContainer id="twitter-embed">
      <a
        className="twitter-timeline"
        href={`https://twitter.com/${timelineAccount}?ref_src=twsrc%5Etfw`}
        data-height="600"
        data-tweet-limit="3"
      >
        Tweets by {timelineAccount}
      </a>
    </EmbedContainer>
  );
};

export default TwitterTimeline;
